module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "策略重点"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("策略重点\n                          "), _c('el-tooltip', {
    attrs: {
      "popper-class": "custom-tooltip",
      "placement": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("策略描述指引（试运行）")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 原则上，应倡导和促进在遵守法律法规和商业道德的前提下，公平有序的竞争。")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 避免使用容易引起歧义或误解的用词，尤其将学术推广活动和提升销量、扩大市场份额等直接关联，或其它容易引起反垄断、违反公平竞争原则风险的敏感用词")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 基于年度BAP内部讨论共识的策略，可基于不同产品及适应症，中央及区域差异分别制定策略描述；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 基于策略及落实的实际需求选择最聚焦、简单的分类进行策略拆分；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 特别注意推广及非推广类会议活动及项目的匹配度；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 应该避免使用过于复杂或行业术语过多的语言。清晰、简洁、易于 理解；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 基于材料审核的参考原则，谨慎用语，注意措辞分寸。不应含有明示或暗示的不科学、不合理的用词，尤其是明确的禁忌用语，如超适应症、销量翻 5 倍、医院份额＞ 50 、抵御竞争等")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 策略描述可基于策略及业务需求定期更新，但不建议频繁调整变化.")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 如业务团队有疑问，建议其及时咨询法务合规BP")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-warning-outline",
    staticStyle: {
      "font-size": "16px"
    }
  })])], 1), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.searchData.keynote),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keynote", $$v)
      },
      expression: "searchData.keynote"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.medicalField = '';
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "departId", $$v)
      },
      expression: "searchData.departId"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.departsList : _vm.userInfo.loginDeparts)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Franchise/DA"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.medicalFieldList : _vm.getMedicalFieldArray(_vm.searchData.departId, true))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "团队"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.teamList : _vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.productId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "productId", $$v)
      },
      expression: "searchData.productId"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "btn-search",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": '/static/file/strategy.xlsx?t=' + new Date().getTime()
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    }
  }, [_vm._v("导出模板")])], 1), _vm._v(" "), _c('span', [_c('common-upload', {
    attrs: {
      "importApi": _vm.crudApi,
      "importType": "Excel",
      "onSuccess": _vm.handleUpdateSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    }
  }, [_vm._v("批量上传")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handlerExportExcelClick()
      }
    }
  }, [_vm._v("批量导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.selectedData.length <= 0,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleBatchDeleteClick()
      }
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("添加策略")])], 1)]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "addNewOrEditData": _vm.addNewOrEditData,
      "searchData": _vm.searchData,
      "searchDataLikeField": {
        'keynote': '*'
      },
      "crudApi": _vm.crudApi,
      "tableData": _vm.strategyData,
      "showEditFormTitle": false,
      "beforeSave": _vm.beforeSave,
      "afterSave": _vm.handleStrategyChange,
      "afterDelete": _vm.handleStrategyChange,
      "selectedDataArray": _vm.selectedData,
      "otherValid": _vm.validUpload,
      "addSuccessMessages": "添加策略成功",
      "editSuccessMessages": "编辑策略成功",
      "deleteSuccessMessages": "删除策略成功",
      "deleteBatchSuccessMessages": "批量删除策略成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.strategyData = $event
      },
      "update:table-data": function($event) {
        _vm.strategyData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "width": "60",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "departId",
      "label": "部门"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "medicalField",
      "width": "135"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('div', [_vm._v("Franchise/DA")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "teamL4",
      "label": "团队"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "productId",
      "label": "产品"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "keynote",
      "label": "策略重点"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "updateTime",
      "label": "更新时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "updateBy",
      "label": "操作人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                    编辑\n                  ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                    删除\n                  ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "customTitle"
  }, [_vm._v("策略重点")]), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门",
      "prop": "departId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.medicalField = '';
        _vm.addNewOrEditData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.addNewOrEditData.departId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "departId", $$v)
      },
      expression: "addNewOrEditData.departId"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.departsList : _vm.userInfo.loginDeparts)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Franchise/DA",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.addNewOrEditData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalField", $$v)
      },
      expression: "addNewOrEditData.medicalField"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.medicalFieldList : _vm.getMedicalFieldArray(_vm.addNewOrEditData.departId, false))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "团队",
      "prop": "teamL4"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "teamL4", $$v)
      },
      expression: "addNewOrEditData.teamL4"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.teamList : _vm.getTeamArray(_vm.addNewOrEditData.departId, _vm.addNewOrEditData.medicalField, false))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "产品",
      "prop": "productId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.addNewOrEditData.productId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "productId", $$v)
      },
      expression: "addNewOrEditData.productId"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "策略重点名称（建议长度在8个字符以内）",
      "prop": "keynote"
    }
  }, [_c('el-input', {
    attrs: {
      "rows": "4",
      "maxlength": "200",
      "type": "textarea",
      "placeholder": "请输入策略重点（建议长度在8个字符以内）"
    },
    model: {
      value: (_vm.addNewOrEditData.keynote),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "keynote", $$v)
      },
      expression: "addNewOrEditData.keynote"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('common-score', {
    ref: "strategyHospital4Strategy",
    attrs: {
      "disabledDownload": !_vm.canDownload,
      "title": "策略重点与医院层级",
      "type": "strategyHospital4Strategy",
      "fileName": "策略重点与医院层级.xlsx",
      "getExportParams": _vm.getScoreExportParams
    }
  })], 1), _vm._v(" "), _c('el-col', [_c('common-score', {
    ref: "strategyOffice",
    attrs: {
      "disabledDownload": !_vm.canDownload,
      "title": "策略重点与科室",
      "type": "strategyOffice",
      "fileName": "策略重点与科室.xlsx",
      "getExportParams": _vm.getScoreExportParams
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "confirmAddNewMessage"
  }, [_c('div', [_c('span', [_vm._v("确认添加策略重点？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存策略重点？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("删除策略重点？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmBatchDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("批量删除策略重点？")])])]), _vm._v(" "), _c('template', {
    staticClass: "tipsFormClass",
    slot: "tipsFormMessage"
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("策略描述指引（试运行）")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 原则上，应倡导和促进在遵守法律法规和商业道德的前提下，公平有序的竞争。")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 避免使用容易引起歧义或误解的用词，尤其将学术推广活动和提升销量、扩大市场份额等直接关联，或其它容易引起反垄断、违反公平竞争原则风险的敏感用词")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 基于年度BAP内部讨论共识的策略，可基于不同产品及适应症，中央及区域差异分别制定策略描述；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 基于策略及落实的实际需求选择最聚焦、简单的分类进行策略拆分；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 特别注意推广及非推广类会议活动及项目的匹配度；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 应该避免使用过于复杂或行业术语过多的语言。清晰、简洁、易于 理解；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 基于材料审核的参考原则，谨慎用语，注意措辞分寸。不应含有明示或暗示的不科学、不合理的用词，尤其是明确的禁忌用语，如超适应症、销量翻 5 倍、医院份额＞ 50 、抵御竞争等")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 策略描述可基于策略及业务需求定期更新，但不建议频繁调整变化.")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 如业务团队有疑问，建议其及时咨询法务合规BP")])])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e8ad199e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8ad199e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/bizmanagement/strategy/index.vue
// module id = 1605
// module chunks = 7